
import PlusIcon from '@/static/svg/plus-icon.svg'
import MinusIcon from '@/static/svg/minus-icon.svg'

export default {
  components: {
    PlusIcon,
    MinusIcon,
  },
  props: {
    quantity: {
      type: [Number, String],
      default: 1,
    },
    minQuantity: {
      type: Number,
      default: 1,
    },
    maxQuantity: {
      type: Number,
      default: 36,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    decreaseQuantity() {
      if (this.quantity > this.minQuantity) {
        this.$emit('quantity-updated', parseInt(this.quantity, 10) - 1)
      }
    },
    increaseQuantity() {
      if (this.quantity < this.maxQuantity) {
        this.$emit('quantity-updated', parseInt(this.quantity, 10) + 1)
      }
    },
  },
}
